import { PackageModulesFormWebComponent } from './component/PackageModulesFormWebComponent';
import { WEB_COMPONENT_PACKAGE_MODULES_FORM } from '../../../webcomponents.constants';

export { PackageModulesFormWebComponent };

window.customElements.define(WEB_COMPONENT_PACKAGE_MODULES_FORM, PackageModulesFormWebComponent);
